import { combineReducers } from 'redux';
import contentTagDetails from './content-tag-details-reducer';

const tagReducer = combineReducers({
  contentTagDetails,
});

export default tagReducer;
